/**
 * Get org_id from localStorage
 * Checks location state first, then localStorage user object, with fallback to direct storage keys
 */
export function getOrgIdFromStorage() {
  // First try to get from localStorage user object (JSON)
  const userStr = localStorage.getItem("user");
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      if (user.org_id) return user.org_id;
    } catch (e) {
      console.error("Error parsing user from localStorage:", e);
    }
  }
  
  // Fallback to direct localStorage keys (for backwards compatibility)
  return localStorage.getItem("org_id") || localStorage.getItem("organizer_id") || null;
}

/**
 * Get user object from localStorage
 */
export function getUserFromStorage() {
  const userStr = localStorage.getItem("user");
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch (e) {
      console.error("Error parsing user from localStorage:", e);
      return null;
    }
  }
  return null;
}

/**
 * Get participant object from localStorage
 */
export function getParticipantFromStorage() {
  const participantStr = localStorage.getItem("participant");
  if (participantStr) {
    try {
      return JSON.parse(participantStr);
    } catch (e) {
      console.error("Error parsing participant from localStorage:", e);
      return null;
    }
  }
  return null;
}
